import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { colors, H1, H4 } from './Styles';

type Props = {
  /** Breadcrumbs to be displayed on top left */
  breadcrumbs?: string[];
  /** Title of the header */
  title?: string | React.ReactNode;
  /** Component at the rightmost */
  actions?: React.ReactNode;
  /** Custom border margin */
  bottom?: number;
};

export const DashboardHeader: React.FC<Props> = ({
  breadcrumbs,
  title,
  actions,
  bottom = 22.5,
}) => {
  return (
    <Conatiner bottom={bottom}>
      {!!breadcrumbs?.length && (
        <Breadcrumbs>
          {breadcrumbs.map((crumb, index) => {
            const isFirst = index === 0;
            const isLast = index === breadcrumbs.length - 1;
            return (
              <Breadcrumb key={`${_.snakeCase(crumb)}-${index}`}>
                <H4 color={isFirst ? colors.primary : undefined}>{crumb}</H4>
                {!isLast && <Slash>/</Slash>}
              </Breadcrumb>
            );
          })}
        </Breadcrumbs>
      )}
      <Body>
        {typeof title === 'string' ? <H1>{title}</H1> : title}
        <Actions>{actions}</Actions>
      </Body>
    </Conatiner>
  );
};

const Conatiner = styled.div<{ bottom: number }>`
  margin-bottom: ${props => props.bottom}px;
`;

const Breadcrumbs = styled.div`
  display: flex;
  align-items: center;
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
`;

const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 18px;
  }
`;

const Slash = styled.span`
  margin: 0 8px;
  font-size: 14px;
  color: #c7cccf;
`;
